module.exports = __webpack_public_path__ + "media/images/e-bilet/clock-10c5bffc6441dda1648ff4ced2a49a62.svg";